import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Assistance Listing: A federal program that provides research funding and helps categorize funding sources. Find more at https://sam.gov/assistance-listings',
    name: 'Assistance Listings',
    partialId: PartialId.Standard.create('assistance_listings'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
